import React from 'react';
import MarketingEmptyState from '../shared/MarketingEmptyState';

const ICON = '/traders/empty-state-icon.png';

export default function TradersEmptyState() {
  return (
    <MarketingEmptyState
      iconSrc={ICON}
      i18nPrefix="tradersDirectory"
      titleId="traders-empty-title"
      primaryTo="/join"
      secondaryTo="/services"
    />
  );
}
